module.exports = __webpack_public_path__ + "img/fccec58.jpg";